module.exports = __webpack_public_path__ + "static/img/TFT Teamfight Tactics.7ac77c42.png";